import { Type } from "../../../models/configuration/definitions/widget";
import { WidgetStateReturn, WidgetUIState } from "../atoms";
import { KTab } from "../KTabsWidget";
import { getWidgetsKeysTemplates } from "./getWidgetsKeysTemplates";

export function isDisplayedTab(value: KTab, widgetStates: WidgetStateReturn[]): boolean {
  const widgetsKey = getWidgetsKeysTemplates(value.templatesConfiguration);
  return isWidgetsRendered(widgetsKey, widgetStates);
}

export function isWidgetsRendered(
  widgets: { id: string; type: Type }[],
  widgetStates: WidgetStateReturn[],
): boolean {
  return widgets.some((ws) => {
    const widg = widgetStates.find(
      (w) =>
        (ws.type === Type.Attachments && w.type === Type.Attachments) ||
        (ws.type === Type.Sheet && w.type === Type.Sheet) ||
        (w.id === ws.id && w.type === ws.type),
    );
    if (widg) {
      return widg.state === WidgetUIState.RENDERED;
    }
    return false;
  });
}
